import SearchAndFilter from './component'

export default SearchAndFilter
